var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 109,
    viewBox: "0 0 186 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6251 60.1706V36.0605H49.2228V95.4203H108.583V60.1706H84.6251Z",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.223 95.4204V36.6514L35.8292 50.313V107.922H97.7819L108.583 95.4204H49.223Z",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.532 95.4199L88.145 107.807",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0094 95.4199L78.6221 107.807",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6289 95.9043L64.7264 107.807",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8175 95.8018L54.1758 107.443",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5397 96.166L42.8979 107.807",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.223 90.5684L36.5513 103.24",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.223 79.0928L35.8292 92.4865",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.223 67.6172L36.2402 80.6",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2231 56.1416L35.8293 69.5348",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.223 44.666L36.3182 57.5702",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.735 16.3945V42.7179H133.581V56.9093H174.095V16.3945H161.735Z",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.652 67.4512H144.138L133.581 56.9093H174.095V16.3945L184.652 25.4605V67.4512Z",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M133.581 56.9092L144.13 67.4581",
    stroke: "#108DA0",
    strokeWidth: 0.59131
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.546 56.9092L153.095 67.4581",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M153.572 56.9092L164.12 67.4581",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M163.923 56.9092L174.472 67.4581",
    stroke: "#108DA0",
    strokeWidth: 1.18262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M174.095 56.9092L184.645 67.4581",
    stroke: "#108DA0",
    strokeWidth: 1.18262
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M174.102 48.1875L184.651 58.7371",
    stroke: "#108DA0",
    strokeWidth: 1.18262
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M174.108 39.4668L184.657 50.0164",
    stroke: "#108DA0",
    strokeWidth: 1.18262
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M174.114 30.7461L184.663 41.2956",
    stroke: "#108DA0",
    strokeWidth: 1.18262
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M174.12 22.0244L184.669 32.574",
    stroke: "#108DA0",
    strokeWidth: 1.18262
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8134 78.1507L71.7119 74.2694V73.4486L79.8306 69.2793V70.6162L73.2765 73.8211L79.8134 76.8144V78.1507Z",
    fill: "#108DA0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.4181 81.2294H81.2006L86.9168 66.9883H88.1514L82.4181 81.2294Z",
    fill: "#108DA0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.801 76.7552L96.3462 73.8211L89.8176 70.5571V69.2373L97.9191 73.4575V74.2782L89.801 78.0999V76.7552Z",
    fill: "#108DA0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5679 1.91406C76.9761 1.91406 75.6811 3.20903 75.6811 4.80084C75.6811 6.39205 76.9761 7.68761 78.5679 7.68761C80.1597 7.68761 81.4546 6.39205 81.4546 4.80084C81.4546 3.20903 80.1597 1.91406 78.5679 1.91406M78.568 9.6005C75.9207 9.6005 73.7677 7.44695 73.7677 4.80025C73.7677 2.15296 75.9207 0 78.568 0C81.2152 0 83.3682 2.15296 83.3682 4.80025C83.3682 7.44695 81.2152 9.6005 78.568 9.6005",
    fill: "#108DA0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_816_2903",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 186,
    height: 109
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 108.513H185.243V0H0V108.513Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_816_2903)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0994 62.252H55.8733V59.8867H54.0994V62.252ZM54.0994 57.5215H55.8733V55.1563H54.0994V57.5215ZM54.0994 52.791H55.8733V50.4258H54.0994V52.791ZM54.0994 48.0606H55.8733V45.6953H54.0994V48.0606Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0996 62.2529H55.8735V88.2706H103.776V90.0445H54.0996V62.2529Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.963 50.4351C162.963 51.6762 161.957 52.6826 160.716 52.6826C159.475 52.6826 158.468 51.6762 158.468 50.4351C158.468 49.1933 159.475 48.1875 160.716 48.1875C161.957 48.1875 162.963 49.1933 162.963 50.4351",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.974 50.4351C153.974 51.6762 152.967 52.6826 151.726 52.6826C150.486 52.6826 149.479 51.6762 149.479 50.4351C149.479 49.1933 150.486 48.1875 151.726 48.1875C152.967 48.1875 153.974 49.1933 153.974 50.4351",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.985 50.4351C144.985 51.6762 143.978 52.6826 142.737 52.6826C141.497 52.6826 140.49 51.6762 140.49 50.4351C140.49 49.1933 141.497 48.1875 142.737 48.1875C143.978 48.1875 144.985 49.1933 144.985 50.4351",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.015 43.9287C166.774 43.9287 165.768 42.9223 165.768 41.6812C165.768 40.44 166.774 39.4336 168.015 39.4336C169.257 39.4336 170.262 40.44 170.262 41.6812C170.262 42.9223 169.257 43.9287 168.015 43.9287",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.015 34.9395C166.774 34.9395 165.768 33.9331 165.768 32.6919C165.768 31.4507 166.774 30.4443 168.015 30.4443C169.257 30.4443 170.262 31.4507 170.262 32.6919C170.262 33.9331 169.257 34.9395 168.015 34.9395",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.015 25.9496C166.774 25.9496 165.768 24.9438 165.768 23.7026C165.768 22.4615 166.774 21.4551 168.015 21.4551C169.257 21.4551 170.262 22.4615 170.262 23.7026C170.262 24.9438 169.257 25.9496 168.015 25.9496",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.396 15.5303C112.229 15.5303 112.063 15.5362 111.896 15.5468C109.961 15.6781 108.193 16.5538 106.917 18.0144C105.641 19.4755 105.01 21.3452 105.141 23.28C105.272 25.2153 106.148 26.9833 107.608 28.2588C110.623 30.8925 115.219 30.5821 117.853 27.567C119.129 26.107 119.759 24.2373 119.629 22.302C119.498 20.3672 118.622 18.5986 117.161 17.3231C115.827 16.1577 114.151 15.5303 112.396 15.5303M112.38 30.6686C110.539 30.6686 108.692 30.0294 107.2 28.7261C105.615 27.3419 104.664 25.4225 104.522 23.3221C104.38 21.2218 105.065 19.1919 106.449 17.6071C107.834 16.0212 109.754 15.0704 111.854 14.9285C113.954 14.7866 115.984 15.4713 117.57 16.8562C119.155 18.241 120.106 20.1598 120.248 22.2602C120.389 24.3611 119.705 26.3899 118.32 27.9758C116.764 29.7568 114.577 30.6686 112.38 30.6686M105.105 16.4318C101.598 20.4462 102.011 26.565 106.026 30.0715C107.97 31.7703 110.458 32.61 113.036 32.4356C115.612 32.2617 117.966 31.0951 119.665 29.1502C123.172 25.1364 122.758 19.0176 118.744 15.5111C114.73 12.0046 108.611 12.4174 105.105 16.4318M112.37 33.0786C109.883 33.0786 107.508 32.1899 105.617 30.5384C101.346 26.8066 100.906 20.2957 104.638 16.0241C108.369 11.7519 114.88 11.3119 119.152 15.0437C123.424 18.7748 123.863 25.2863 120.132 29.5586C118.325 31.6275 115.819 32.8693 113.078 33.055C112.841 33.0703 112.605 33.0786 112.37 33.0786",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.572 30.1106L143.53 34.8605L145.202 33.4674L142.389 30.091L145.215 26.6053L143.525 25.2346L139.572 30.1106ZM143.439 35.8687L138.645 30.1164L143.42 24.2275L146.222 26.5005L143.316 30.0845L146.211 33.559L143.439 35.8687Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.265 33.4674L150.937 34.8605L154.896 30.1106L150.942 25.2346L149.252 26.6059L152.079 30.091L149.265 33.4674ZM151.028 35.8692L148.257 33.559L151.151 30.0845L148.245 26.5005L151.047 24.2275L155.823 30.1164L151.028 35.8692Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1448 84.0117H26.225V83.1123H12.1448V84.0117Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 78.9183H26.2258V78.0195H0V78.9183Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1448 72.9261H26.225V72.0273H12.1448V72.9261Z",
    fill: "#8F8F8F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmenu);
export default __webpack_public_path__ + "static/media/submenu.59cb4ff5da245d5bc8e0890df7b307ed.svg";
export { ForwardRef as ReactComponent };